import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as archivedProofOfGovIdState from '../employee-detail.reducer';
import * as archivedProofOfGovIdReducer from '../reducers/archived-proof-gov-id.reducer';

export const getPreviousProofOfGovIds = createSelector(
  archivedProofOfGovIdState.getArchivedProofGovIdsState,
  archivedProofOfGovIdReducer.getPreviousProofGovIds
);
